import { Modal, Button, Form } from 'react-bootstrap';
import { useState, useEffect } from 'react';

const empty = {
  bankAuthId: '', serviceName: '', baseUrl: '',
  endpointPath: '', msgDefIdr: '', bizSvc: ''
};

const BankServiceModal = ({ show, onHide, onSave, initial }) => {
  const [form, setForm] = useState(empty);
  useEffect(() => setForm(initial ?? empty), [initial]);
  const c = (f, v) => setForm({ ...form, [f]: v });

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{initial ? 'Edit service' : 'New service'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className='mb-2'>
          <Form.Label>BankAuth ID</Form.Label>
          <Form.Control type='number' value={form.bankAuthId}
            onChange={e=>c('bankAuthId',e.target.value)} />
        </Form.Group>
        {['serviceName','baseUrl','endpointPath','msgDefIdr','bizSvc'].map(f =>
          <Form.Group key={f} className='mb-2'>
            <Form.Label>{f}</Form.Label>
            <Form.Control value={form[f]} onChange={e=>c(f,e.target.value)} />
          </Form.Group>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onHide}>Cancel</Button>
        <Button variant='primary'  onClick={() => onSave(form)}>Save</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default BankServiceModal;
